import { useEffect, useState, useCallback } from 'react';

export interface SessionUser {
  id: string;
  email: string;
  name: string;
  avatar_url?: string;
}

export interface SessionAuth {
  isAuthenticated: boolean;
  user: SessionUser | null;
  isLoading: boolean;
}

/**
 * Check if an auth_session cookie exists
 * Polls for session data from api.smallbizinnovation.com/auth/session
 */
export function useSessionAuth(): SessionAuth {
  const [auth, setAuth] = useState<SessionAuth>({
    isAuthenticated: false,
    user: null,
    isLoading: true,
  });

  const checkAuth = useCallback(async () => {
    try {
      // Attempt to fetch current session
      // This endpoint requires the auth_session cookie to be present
      const response = await fetch('https://api.smallbizinnovation.com/auth/session', {
        method: 'GET',
        credentials: 'include', // Include cookies
      });

      if (response.ok) {
        const sessionData = (await response.json()) as {
          user?: SessionUser;
          ok?: boolean;
        };
        if (sessionData.user) {
          setAuth({
            isAuthenticated: true,
            user: sessionData.user,
            isLoading: false,
          });
          return;
        }
      }

      // No valid session
      setAuth({
        isAuthenticated: false,
        user: null,
        isLoading: false,
      });
    } catch (error) {
      console.error('[useSessionAuth] Error checking session:', error);
      setAuth({
        isAuthenticated: false,
        user: null,
        isLoading: false,
      });
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return auth;
}
